export default "__VITE_ASSET__cg1P4lA1__"